// extracted by mini-css-extract-plugin
export default {"inputWrapperForMedicalTreatment":"_3ddxbWN6L-SgXkSmVc3qj9 _16KVIa6ObhuMuCWqSorhWK"};